module.exports = __webpack_public_path__ + "img/9.5c6b7cfd.png";